import React from 'react';

import adminApiClient from 'api/adminApiClient';
import FormikFileUpload from 'components/formik/FormikFileUpload';
import { generateUploadFileList, getFileUploadMessages } from 'utils/fileUtils';
import BaseDraggerContent from 'components/wrappers/BaseFileUpload/BaseDraggerContent';
import { ResourceDownloadResponse } from 'api/backofficeApiClient';
import UploadList from 'components/wrappers/BaseFileUpload/UploadList';

const FILE_TYPES = ['DOC', 'DOCX', 'PDF', 'RTF'];
const fileUploadMessages = getFileUploadMessages({
  fileTypes: FILE_TYPES,
});

type Props = {
  fieldName: string;
  file?: ResourceDownloadResponse;
};

export default React.memo((props: Props) => {
  const { fieldName, file } = props;

  const defaultFileList = file ? generateUploadFileList(file) : [];
  const uploadFileLinkFunction =
    adminApiClient.getOnboardingDocumentationUploadLink.bind(adminApiClient);

  return (
    <FormikFileUpload
      name={fieldName}
      isDraggable
      defaultFileList={defaultFileList}
      acceptedFileSize={10}
      acceptedFileFormat={[
        '.doc',
        '.docx',
        '.pdf',
        '.rtf',
        'text/rtf',
        'application/msword',
        'application/pdf',
        'application/rtf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ]}
      getUploadList={UploadList}
      messages={fileUploadMessages}
      uploadLinkFunction={uploadFileLinkFunction}
    >
      {() => <BaseDraggerContent fileTypes={FILE_TYPES} />}
    </FormikFileUpload>
  );
});
